// src/pages/CallbackPage.jsx
import React, { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';

function CallbackPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [errorHandled, setErrorHandled] = useState(false);

  useEffect(() => {
    // Handle "No matching state found" error specifically
    if (auth.error && auth.error.message && auth.error.message.includes('No matching state')) {
      if (!errorHandled) {
        setErrorHandled(true);
        console.error('State mismatch error detected. This can happen if:');
        console.error('1. The redirect_uri doesn\'t match Cognito configuration');
        console.error('2. Browser storage was cleared between login and callback');
        console.error('3. There\'s a domain mismatch (e.g., www vs non-www)');
        console.error('Current URL:', window.location.href);
        console.error('Current origin:', window.location.origin);
        
        // Clear any stale auth state and redirect to home
        auth.removeUser().then(() => {
          setTimeout(() => {
            navigate('/home', { replace: true });
          }, 1000);
        });
        return;
      }
    }

    // Wait until the auth process is finished loading
    if (!auth.isLoading) {
      if (auth.isAuthenticated) {
        // After successful authentication, navigate to /app
        navigate('/app', { replace: true });
      } else if (auth.error && !errorHandled) {
        // If authentication failed and we haven't handled it yet, navigate to /home
        console.error('Authentication error:', auth.error);
        navigate('/home', { replace: true });
      }
    }
  }, [auth.isLoading, auth.isAuthenticated, auth.error, navigate, errorHandled]);

  if (auth.error && auth.error.message && auth.error.message.includes('No matching state')) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h2>Authentication Error</h2>
        <p>There was a problem completing the login process.</p>
        <p style={{ fontSize: '0.9rem', color: '#666' }}>
          This usually happens when there's a mismatch between the login URL and callback URL.
        </p>
        <p style={{ fontSize: '0.85rem', color: '#999', marginTop: '1rem' }}>
          Redirecting you back to the home page...
        </p>
      </div>
    );
  }

  return <div>Processing authentication...</div>;
}

export default CallbackPage;
